import {EventEmitter, Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {DatevNotificationService, DatevNotificationSeverity} from '@datev/ngx-ui-components';
import {AppNameEnum,  NachdigalService} from '@nachdigal';
import {LoaderService} from './loader.service';
import {concatMap} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable()
export class PreviewDocumentService {
    public onClosePdfViewer = new EventEmitter<void>();
    constructor(
        @Inject('Window') private readonly window: Window,
        @Inject(DOCUMENT) private readonly document: Document,
        private readonly translateService: TranslateService,
        private readonly notificationService: DatevNotificationService,
        private readonly loadingService: LoaderService,
        private readonly nachdigalService: NachdigalService,
        private readonly router: Router) {
    }

    public getPdfBlob(taskId: string, isUebermittelt: boolean, appName?: AppNameEnum, navback = false) : Observable<Blob> {
      if (isUebermittelt) {
        return this.nachdigalService.getPreview(taskId);
      } else {
        return this.nachdigalService.getTaskData(taskId).pipe(
          concatMap(taskData => {
            const body = JSON.stringify(taskData.nutzdaten);
            return this.nachdigalService.convertJsonToXml(taskId, appName, body);
          }),
          concatMap(converted => this.nachdigalService.postPreview(taskId, converted.ericDataTypeVersion, converted.ericXml))
        );
      }
    }
    public getSingleFilePdfBlob(taskId: string, docId: string) : Observable<Blob> {
        return this.nachdigalService.getSingleFilePreview(taskId,docId);
    }
    public displayPdfData(taskId: string, isUebermittelt: boolean, appName?: AppNameEnum, navback = false): void {
        this.loadingService.isLoading = {isLoading: true, immediate: true};
        this.notificationService.close('sendError');
        this.notificationService.close('converterError');
        if (isUebermittelt) {
            this.nachdigalService.getPreview(taskId).subscribe(data => this.showTab(data), this.handleException.bind(this));
        } else {
            this.nachdigalService.getTaskData(taskId).subscribe(taskData => {
                const body = JSON.stringify(taskData.nutzdaten);
                this.nachdigalService.convertJsonToXml(taskId, appName, body).subscribe(converterOutput => {
                    this.nachdigalService.postPreview(taskId, converterOutput.ericDataTypeVersion, converterOutput.ericXml)
                        .subscribe(data => {
                            this.showTab(data);
                        }, this.handleException.bind(this));
                });
            });
        }
        if (navback) {
            this.router.navigate(['']);
        }
    }

    public handleException(): void {
        this.loadingService.isLoading = {isLoading: false};
        const exceptionTitle = 'COMMON_UI.NOTIFICATIONS.CONVERTER_ERROR.TITEL';
        const exceptionMessage = 'COMMON_UI.NOTIFICATIONS.CONVERTER_ERROR.MESSAGE';
        this.notificationService.showAlert(DatevNotificationSeverity.Error,
            this.translateService.instant(exceptionTitle), null,
            this.translateService.instant(exceptionMessage), [{id: 'converterErrorOk', label: 'OK'}], 'converterError');
    }

    private showTab(blob: Blob): void {
        this.loadingService.isLoading = {isLoading: false};
        const blobDocument: Blob = new Blob([blob], {type: 'application/pdf'});
        const blobPDF = {
            blob: blobDocument,
            blobUrl: URL.createObjectURL(blobDocument)
        };
        const aTag = document.createElement('A');
        document.body.appendChild(aTag);
        aTag.setAttribute('style', 'display: none;');
        aTag.setAttribute('href', blobPDF.blobUrl);
        aTag.setAttribute('target', '_blank');
        aTag.click();
        aTag.remove();
        window.addEventListener('beforeunload', () => { // NOSONAR - false positive
            URL.revokeObjectURL(blobPDF.blobUrl);
        });
    }
}
